import Dexie from "dexie";

export const offlineDb = new Dexie("venderShopOfflineDB");

offlineDb.version(1).stores({
  orders: "++id,offline_id,sync_status,created_at",
});

offlineDb.version(2).stores({
  orders: "++id,offline_id,sync_status,created_at",
  api_cache: "key,updated_at",
});

